import actionTypes from 'SRC/modules/redux/actionTypes'

export const setCities = (cities) => {
  return {
    type: actionTypes.SET_CITIES,
    payload: cities
  }
}
